export enum Tristate {
  NORMAL = 0,
  SPINNING = 1,
  FAILURE = 2,
}

export function tristateTask<T>(func: () => Promise<T>, setter: (arg0: Tristate) => void) {
  setter(Tristate.SPINNING);
  const result = func();
  result.then(
    () => {
      setter(Tristate.NORMAL);
    },
    () => {
      setter(Tristate.FAILURE);
    },
  );
  return result;
}
